import React from 'react';
import { DASHBOARD_COLORS } from '../../../constants';
import { SearchIcon, XIcon } from '../../../icons/animated';
import { PieCartWithStats, Tabs } from '../../../ui';
import { useAdminDashboard } from './Hooks';

export const AdminDashboard = () => {
  const {
    loading,
    timeData,
    activeTab,
    searchTerm,
    setSearchTerm,
    renderTable,
    setActiveTab,
    tabs,
    orderedJobOpenings,
    mappedUserAssessments,
  } = useAdminDashboard();

  return (
    <div className='w-full min-w-0 flex flex-col gap-5 p-1 sm:p-2'>
      <div className='flex flex-col gap-5 mx-auto w-full min-w-0'>
        { /* Apple Style Page Header */ }
        <div className='flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1 shrink-0'>
          <div>
            <h1 className='text-2xl font-bold text-slate-900 tracking-tight'>
              Overview
            </h1>
            <p className='text-xs text-slate-500 font-medium mt-0.5'>
              Real-time analytics and recruitment overview
            </p>
          </div>
        </div>

        { /* Apple Chart Cards Grid */ }
        <div className='grid grid-cols-1 gap-4 shrink-0 md:grid-cols-2 lg:grid-cols-4'>
          <div className='col-span-1 lg:col-span-2'>
            <PieCartWithStats
                label={'Job Opening'}
                data={orderedJobOpenings}
                loading={loading}
                colors={DASHBOARD_COLORS}
                type='bar'
            />
          </div>
          <PieCartWithStats
              label={'Assessment Type'}
              data={timeData?.assessments}
              loading={loading}
              colors={DASHBOARD_COLORS}
              type='donut'
          />
          <PieCartWithStats
              label={'User Assessment Session'}
              data={mappedUserAssessments || timeData?.userAssessments}
              loading={loading}
              colors={DASHBOARD_COLORS}
              type='bar'
          />
        </div>

        { /* Tab Navigation & Search Bar */ }
        <div className='flex flex-col gap-3.5'>
          <div className='shrink-0 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
            <Tabs
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={(tab) => {
                  setActiveTab(tab);
                  setSearchTerm(''); // Clear search when tab changes
                }}
            />
            { /* Apple Spotlight Search Input */ }
            <div className='relative flex w-full items-center sm:w-80 group'>
              <div className='absolute left-3 pointer-events-none text-slate-400 group-hover:text-emerald-500 transition-colors'>
                <SearchIcon size={16} />
              </div>
              <input
                  type='text'
                  placeholder={`Search ${activeTab}...`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className='min-h-10 w-full bg-slate-100/80 hover:bg-slate-100 focus:bg-white border border-slate-200/60 focus:border-emerald-500/60 focus:ring-4 focus:ring-emerald-500/10 rounded-xl py-2 pl-9 pr-9 text-[13px] placeholder:text-slate-400 font-medium text-slate-800 transition-all shadow-xs'
              />
              { searchTerm && (
                <button
                    onClick={() => setSearchTerm('')}
                    className='absolute right-2.5 p-1 rounded-md text-slate-400 hover:text-slate-600 transition-colors'
                    aria-label="Clear search"
                >
                  <XIcon size={14} />
                </button>
              ) }
            </div>
          </div>

          { /* Table Container with Apple Continuous Curvature */ }
          <div className='min-w-0 bg-white rounded-2xl border border-slate-200/70 shadow-[0_1px_3px_rgba(0,0,0,0.03),0_4px_12px_rgba(0,0,0,0.02)] overflow-hidden'>
            { renderTable() }
          </div>
        </div>
      </div>
    </div>
  );
};
